module.exports = __webpack_public_path__ + "static/img/news1.a28d56f1.png";